import { render, staticRenderFns } from "./show.vue?vue&type=template&id=591de034&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('591de034')) {
      api.createRecord('591de034', component.options)
    } else {
      api.reload('591de034', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=591de034&", function () {
      api.rerender('591de034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms/show.vue"
export default component.exports